import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import tw from "tailwind-styled-components";
import Icon from "../icons";
import { SButton, SFlex } from ".";
export const DialogSubtitle = ({ children })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "mt-2 pl-1",
        children: /*#__PURE__*/ _jsx("p", {
            className: "text-sm text-white",
            children: children
        })
    });
};
const CloseIconContainer = tw.button`
  absolute
  top-[10px]
  right-[10px]
  transition
  ease-in-out
  duration-100
  cursor-pointer
  rounded-xl
  border
  border-white
  border-opacity-7
  p-[8px]

  bg-grayscale-darker

  hover:bg-grayscale-darker
`;
const ActionSection = ({ children })=>{
    return /*#__PURE__*/ _jsx(SFlex, {
        direction: "col",
        gap: "1",
        margin: "mt-5",
        children: children
    });
};
const Action = ({ children, onClick = ()=>{}, disabled = false })=>{
    return /*#__PURE__*/ _jsx(SButton, {
        disabled: disabled,
        onClick: onClick,
        children: children
    });
};
const Title = ({ children })=>{
    return /*#__PURE__*/ _jsx(Dialog.Title, {
        as: "h3",
        className: "text-lg font-medium leading-6 text-white pl-1",
        children: children
    });
};
/**
  min-w-[400px]
  sm:min-w-[90vw]
  md:min-w-[90vw]
  lg:min-w-[90vw]
  xl:min-w-[90vw]
 */ const PanelStyles = (noPadding)=>`
  inline-block
  align-middle
  transition-all
  transform
  rounded-2xl
  w-full

  min-w-[90vw]
  sm:min-w-[400px]


  text-white
  text-left
  bg-grayscale-dark
  shadow-2xl border border-white border-1 border-opacity-10

  my-8
  ${!noPadding ? "p-6" : ""}
`;
const FullScreenPanelStyles = (noPadding)=>`
  ${PanelStyles(noPadding)}
  !m-0
  w-[calc(100vw_-_100px)]
  h-[calc(100vh_-_100px)]
  bg-[url('https://assets.website-files.com/61b63629f760bb842bf9c498/61b8b4d1deaf23bc5877720b_bg-2.jpg')]
`;
const MaxWidths = {
    sm: "md:max-w-sm",
    md: "md:max-w-md",
    lg: "md:max-w-lg",
    xl: "md:max-w-xl",
    "2xl": "md:max-w-2xl",
    "3xl": "md:max-w-3xl"
};
const Content = ({ children, onClose, maxWidth = "md", className = "", isFullScreen = false, hideCloseIcon = true, noPadding = false })=>{
    const panelMaxWidth = MaxWidths[maxWidth];
    const styles = isFullScreen ? FullScreenPanelStyles(noPadding) : `${PanelStyles(noPadding)} ${panelMaxWidth} !max-w-[90vw] ${className || ""}`;
    return /*#__PURE__*/ _jsxs(Dialog.Panel, {
        className: styles,
        children: [
            !hideCloseIcon && /*#__PURE__*/ _jsx(CloseIconContainer, {
                onClick: onClose,
                children: /*#__PURE__*/ _jsx(Icon, {
                    name: "MdClose"
                })
            }),
            children
        ]
    });
};
const SModal = ({ children, isOpen, onClose })=>{
    return /*#__PURE__*/ _jsx(Transition, {
        appear: true,
        show: isOpen,
        as: Fragment,
        children: /*#__PURE__*/ _jsxs(Dialog, {
            className: "fixed pin inset-0 z-[999999] overflow-y-auto pointer-events-auto",
            onClose: onClose,
            children: [
                /*#__PURE__*/ _jsx(Transition.Child, {
                    as: Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ _jsx(Dialog.Overlay, {
                        className: "fixed inset-0  bg-[#13151A] bg-opacity-80  transition-opacity"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "flex min-h-full items-center justify-center p-4 text-center",
                        children: /*#__PURE__*/ _jsx(Transition.Child, {
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: children
                        })
                    })
                })
            ]
        })
    });
};
SModal.Content = Content;
SModal.Title = Title;
SModal.ActionSection = ActionSection;
SModal.Action = Action;
SModal.SubTitle = DialogSubtitle;
export default SModal;
